import React, { Component } from 'react';
import Section from '../../../../components/MobileMenu/Page/Section/Section';
import List from '../../../../components/MobileMenu/Page/Section/SectionTemplate/List';
import FreeContent from '../../../../components/MobileMenu/Page/Section/SectionTemplate/FreeContent';
import SubscribeToPro from '../../../../components/MobileMenu/Page/Section/SectionTemplate/SubscribeToPro';
import { advertisingMarketing, ecommerceRetail, moreTopics, dataTools, proPlusDataTools } from '../../../Navigation/NavigationMenu/MenuTemplates/Data';
import BuildServiceUrl from '../../../../helpers/ServiceUrlBuilder';
import config from '../../../../config';
import MobileUserMenu from '../MobileUserMenu/MobileUserMenu';
import CalendarIcon from '../../../../theme/svgs/calendar';
import './NavigationPage.scss';
import InviteOthersMobile from '../../../../theme/svgs/inviteOthersMobile';

export default class NavigationPage extends Component<
    {
        // props
        authenticated: boolean;
        enablePodRedirection: boolean;
        pod: string;
        navOpen: boolean;
        hasProRole: boolean;
        isIpUser: boolean;
        openCalMenuFn: any;
        triggerOpenIacModal: () => void;
    },
    {
        // state
        activeTitle: string;
    }
> {
    constructor(props) {
        super(props);
        this.state = {
            activeTitle: '',
        };
        this.handleTitleClick = this.handleTitleClick.bind(this);
    }

    public handleTitleClick = (title) => {
        this.setState((prevState) => ({
            activeTitle: title === prevState.activeTitle ? '' : title,
        }));
    }

    public render() {
        const { authenticated, enablePodRedirection, pod, hasProRole, isIpUser, openCalMenuFn, triggerOpenIacModal } = this.props;
        const { activeTitle } = this.state;

        const emarketerProServiceUrl = config.emarketerProServiceUrl;
        const alertsServiceUrl = config.alertsServiceUrl;
        const profileUrl = emarketerProServiceUrl + '/MyAccount/EditProfile.aspx';
        const contactUrl = config.emarketerBaseUrl + '/contact';
        const logOutUrl = `${config.subscriptionsServiceUrl}/Logout` + (!enablePodRedirection ? '' : `?returnUrl=${encodeURIComponent(window.location.href)}`);
        const currentUrl = window.location.href;
        const referAColleagueUrl = `${config.emarketerProServiceUrl}/Extranet/Registration/ReferralForm.aspx?ReturnUrl=${currentUrl}&RegistrationSource=branding`;

        return (
            <div className="mobile-page__navigation">
                {!authenticated ? (
                    <Section>
                        <FreeContent renderContent={this.props.navOpen} pod={pod} />
                    </Section>
                ) : null}

                {!authenticated ? (
                    <Section>
                        <SubscribeToPro renderContent={this.props.navOpen} />
                    </Section>
                ) : null}

                {/* PROMOTIONAL SECTION */}
                {/* <Section
                    title="Retail Media Networks"
                    url={`${BuildServiceUrl(pod, 'topics')}/category/Retail%20Media%20Networks`}
                    subUrl={`${BuildServiceUrl(pod, 'topics')}/category/Retail%20Media%20Networks`}
                    subTitle="See All"
                >
                    <div className="mobile-page__promo">
                        Discover the latest trends and insights in the world of Retail Media Networks with our comprehensive coverage.
                    </div>
                </Section> */}
                {/* PROMOTIONAL SECTION */}

                <Section
                    title={advertisingMarketing.name}
                    url={BuildServiceUrl(pod, 'topics')}
                    subTitle="See All"
                    subUrl={`${BuildServiceUrl(pod, 'topics')}/industry/${advertisingMarketing.slug}`}
                    handleTitleClick={this.handleTitleClick}
                    activeTitle={activeTitle}
                >
                    <List data={advertisingMarketing.children} type="Topics" pod={pod} renderContent={this.props.navOpen} />
                </Section>

                <Section
                    title="Ecommerce"
                    url={BuildServiceUrl(pod, 'topics')}
                    subTitle="See All"
                    subUrl={`${BuildServiceUrl(pod, 'topics')}/industry/${ecommerceRetail.slug}`}
                    handleTitleClick={this.handleTitleClick}
                    activeTitle={activeTitle}
                >
                    <List data={ecommerceRetail.children} type="Industries" pod={pod} renderContent={this.props.navOpen} />
                </Section>

                <Section
                    title={moreTopics.name}
                    url={BuildServiceUrl(pod, 'topics')}
                    subTitle="See All"
                    subUrl={BuildServiceUrl(pod, 'topics')}
                    handleTitleClick={this.handleTitleClick}
                    activeTitle={activeTitle}
                >
                    <List data={moreTopics.children} type="Industries" pod={pod} renderContent={this.props.navOpen} />
                </Section>

                <Section
                    title={dataTools.name}
                    url={`${config.emarketerBaseUrl}/products/pro-plus/`}
                    subTitle="See All"
                    subUrl={`${config.emarketerBaseUrl}/products/pro-plus/`}
                    target="_blank"
                    handleTitleClick={this.handleTitleClick}
                    activeTitle={activeTitle}
                >
                    <span className="data-tools-heading">Data Tools</span>
                    <div className="mobile-page-section__border-style mobile-page-section__border-style--tight" />
                    <List data={dataTools.children} type={dataTools.name} pod={pod} renderContent={this.props.navOpen} />
                    <span className="pro-plus-label">PRO+</span><span className="data-tools-heading"> Data Tools</span>
                    <div className="mobile-page-section__border-style mobile-page-section__border-style--tight" />
                    <List data={proPlusDataTools.children} type={proPlusDataTools.name} pod={pod} renderContent={this.props.navOpen} />
                </Section>

                {!hasProRole ? <Section title="Pricing" url={`${config.publicUrl}pricing`} target="_blank" /> : null}

                <Section title="Events" url={`${config.publicUrl}events`} target="_blank" />

                <Section title="Podcasts" url={`${BuildServiceUrl(pod, 'articles')}/topics/emarketer-podcast`} />

                {/* LOGGED IN - SPECIAL CASE - ONLY SHOW TO NON IPAUTH */}
                {!isIpUser && authenticated ? (
                    <div className="mobile-page-nav-row">
                        <MobileUserMenu title={'Profile & Newsletters'} url={profileUrl} icon={'icon-newspaper-o'} />
                        {config.enableCalendarWidget ? (
                            <MobileUserMenu title={'Upcoming & Noteworthy Content'} func={openCalMenuFn} svgIcon={<CalendarIcon />} />
                        ) : null}
                        <MobileUserMenu title={'Alerts'} url={alertsServiceUrl} icon={'icon-bell-o'} />
                    </div>
                ) : null}
                {/* LOGGED IN */}
                {authenticated ? (
                    <div className="mobile-page-nav-row">
                        {!hasProRole ? <MobileUserMenu title={'Invite a Colleague'} func={triggerOpenIacModal} svgIcon={<InviteOthersMobile />} /> : null}
                        <MobileUserMenu title={'Contact'} url={contactUrl} icon={'icon-paper-plane-o'} />
                    </div>
                ) : null}

                <div className="mobile-page-logout">
                    <a className="mobile-page-logout__link" href={logOutUrl}>
                        <span className="mobile-page-logout__title">Logout</span>
                        <div className={`mobile-page-logout__icon`}>
                            <span className={'icon-sign-out'} />
                        </div>
                    </a>
                </div>
            </div>
        );
    }
}
